import { produce } from 'immer';
import { ScopedType } from './scoped-type';

const SLICE = 'map';
const Type = ScopedType('MAP');
const REFRESH = Type('REFRESH');

export const selectors = {
  refresh: (state) => state[SLICE].refresh,
};

const reducerHandlers = {
  [REFRESH]: (state) => {
    state.refresh = Date.now();
  },
};

export const actions = {
  refresh: () => ({ type: REFRESH }),
};

export const reducers = {
  [SLICE]: (state = {}, { type, payload } = {}) => {
    if (!reducerHandlers[type]) return state;
    return produce(state, (draft) => reducerHandlers[type](draft, payload));
  },
};
